<template>
    <section class="custom-multiselect-person-wrapper" :class="{ 'is-disabled': disabled }" v-tooltip="$t('com.file.multiselect-person-tag.click-to-delete')">
        <img :src="getUserAvata(option.value)" :alt="option.label" class="custom-multiselect-person-wrapper__avatar"  v-if="Number.isInteger(option.value) && !forceHideAvatar && $store.state.settings.runtime.showUserAvatarInMultiSelect"/>
        <span class="custom-multiselect-person-wrapper__label">{{ option.label }}</span>
        <img v-if="removable && !disabled" src="@/assets/icons/components/exit-btn.svg" class="custom-multiselect-person-wrapper__remove" />
    </section>
</template>
<script charset="utf-8">
    export default {
        name: "MultiselectPersonTag",
        props:{
            option: {
                type: Object,
                default: () => ({
                    value: 123,
                    label: "Użytkownik"
                })
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            forceHideAvatar:{
                type: Boolean,
                default: false,
            },
            // "X" po prawej stronie; kliknięcie, jak w całym kafelku, obsługuje rodzic przez @click
            removable: {
                type: Boolean,
                default: false,
            }
        },
        methods:{
            getUserAvata(uid) {
                return `https://ssl.esesja.pl/users/${uid}.jpg`;
            },
        }
    }
</script>
<style lang="scss" scoped>
.custom-multiselect-person-wrapper{
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 7.5px;
    background-color: #e5e5e5;
    border-radius: 18px;
    overflow: hidden;
    padding: 5px;

    &:hover{
        background: #ddd;
        box-shadow: 0 0 5px 2px #b1b1b1;
    }

    &__avatar{
        height: 36px;
        width: 36px;
        vertical-align: middle;
        border-radius: 50%;
    }
    &__remove{
        height: 15px;
    }
}
</style>